export default (popupStepPath) => ({
  initExitIntentPopup() {
    if (this.store.values.exitIntent) return

    if (this.store.values.showDiscountModal) return

    window.addEventListener("mouseout", async (e) => {
      if (e.clientY < 0 && this.listenExitIntent) {
        window.analytics.page(window.getPageName("18-exit-intent-popup"))
        if (this.store.values.token) {
          return window.location.replace(this.store.addTokenHashParam(popupStepPath))
        }

        window.location.replace(popupStepPath)
      }
    })
  },

  async closePopup() {
    this.store.values.showDiscountModal = false
    this.store.values.exitIntent = true
    await this.store.push()
    window.scrollTo(0, 0)
  },
})
